// AUTO-GENERATED by scripts/gen-bor-keys.js — do not edit by hand, do not commit.
export const BOR_SERVICE_URLS = {
  "dev": {
    "EU": "/bor-service",
    "CN": "/bor-service"
  },
  "staging": {
    "EU": "https://bom.test.europe.thebhive.net/bor-service",
    "CN": "https://bom.test.europe.thebhive.net/bor-service"
  },
  "prod": {
    "EU": "https://bom.prod.europe.thebhive.net/bor-service",
    "CN": "https://bom.prod.europe.thebhive.net/bor-service"
  }
} as const;

export const KEYCLOAK_URLS = {
  "dev": "https://keycloak-auth-staging.non-prod.worldly.io",
  "staging": "https://keycloak-auth-staging.non-prod.worldly.io",
  "prod": "https://keycloak-auth.worldly.io"
} as const;
